import { Component } from '@angular/core';

@Component({
  selector: 'smrts-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  standalone: false
})
export class LoadingComponent {

}
